module.exports = __webpack_public_path__ + "static/Roboto-LightItalic-afd48b813752d70b936e73d99b5dca35.ttf";